import React from "react";
import { createRoot } from 'react-dom/client';
import { PredictiveSearchFS } from "../react_components/PredictiveSearchFS.js";

const rootElements = Array.from(document.querySelectorAll('[data-predictive-search-FS-target]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    if (root) {
      root.render(
        <PredictiveSearchFS root={rootEl} />
      );
      rootEl._reactRootContainer = root;
    }
  });
}
